import axios from 'axios';
import { notification } from 'antd';

const adminApi = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
});

const ADMIN_KEYS = ['admin_name', 'admin_email', 'admin_role'];

adminApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            ADMIN_KEYS.forEach((k) => localStorage.removeItem(k));
            notification.warning({
                message: 'Session Expired',
                description: 'Your admin session has expired. Please login again.',
            });
            setTimeout(() => { window.location.href = '/admin/login'; }, 1500);
        }
        return Promise.reject(error);
    }
);

export default adminApi;
